<template>
  <v-row no-gutters v-if="geometry">
    <v-col cols="12">
      <v-row no-gutters class="text-body-2 pt-5" align="center">
        <v-col cols="4" class="point-summary-title-col pr-7"> {{ title }}: </v-col>
        <v-col cols="6" class="font-weight-medium">
          {{ formatCoordinates(geometry.coordinates) }}
        </v-col>
        <v-spacer />
        <v-col cols="2" class="text-right">
          <slot name="append" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';
import { transform } from 'ol/proj';
export default {
  name: 'PointSummary',
  props: {
    titlePath: {
      type: String,
    },
    titleStraight: {
      type: String,
    },
    geometry: {
      type: Object,
    },
  },
  computed: {
    cursorPositionEpsg: get('map/cursorPositionEpsg'),
    title() {
      return this.titleStraight || this.$i18n.t(this.titlePath);
    },
  },
  methods: {
    formatCoordinates(coords) {
      return transform(coords, this.$_config.defaultEpsg, this.cursorPositionEpsg)
        .map(coord => coord.toFixed(4))
        .join(', ');
    },
  },
};
</script>
<style lang="scss" scoped>
.point-summary-title-col {
  color: map-get($colors, 'fontlight');
}
</style>
